

import React, {Component} from "react"
import { Loading } from '../component/BaseComponent';
import { HttpsRequest, Alerts } from '../component/Utils';
import {SideView, MainViewWrapper} from "./loginui" ; 
import { APIRoute, APPRoute, RespStatus } from "../component/texts";
import {FormGroup} from "../component/form";
import {Link } from 'react-router-dom'; 

 

interface IStateType {

    data: Record<string, number | string | unknown>
    form: Record<string, any>[];
    isbusy: boolean;        
    email?: string ;
    
}

export default class ResetPasswd extends Component<IProps, IStateType> {

    constructor(props: IProps){

        super(props)
        this.state = {
            
            form: [],
            isbusy: false,
            data: {},            
            email: ''  
        }
    }

    render(){
         
        return (

            <div className="row">
                <SideView /> 
                <div className="col-md-7 posrel"> 
                <MainViewWrapper>
                <div className="padh10 mt2">
                     
                    <form method='post' autoComplete="off" onSubmit={this.confirm_email}>
                        
                        <div className="d-flex flex-column justify-content-around mt5" style={{minHeight: 250}}>

                        <div className="d-flex justify-content-between align-items-center">

                            <h3> Reset Password </h3>
                            <Link to={APPRoute.login}>
                                Back to login 
                            </Link>
                        </div>

                        {
                            this.state.form.map((fld, idx) => {                                
                                return <FormGroup key={`sign${idx}`}
                                    obj={fld} 
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        this.onchange(e);  
                                    }} />
                                
                            })
                        }
                         
                        </div>
                        <div className="d-grid">
                            <button type="submit" className="btn btn-primary btn-lg btn-block">
                                Confirm Email 
                            </button>
                        </div>
                         
                    </form>
                </div>
                </MainViewWrapper>
                {this.state.isbusy && <Loading />}
                </div>
            </div> 
        )
 
    }

    initfunc = () => {
        
        console.log(this.props.location)
        const {form, email} = this.props.location.state; 
        this.setState({form: form, data:{email}}) ; 
 
    }
 

    componentDidMount(): void {        
        this.initfunc();
    }

    onchange = (event: React.ChangeEvent<HTMLInputElement>) => {
                
        const name: string = event.target.name;
        let value: string = event.target.value;        
        const {data} = this.state ; 
                        
        this.setState({ data: Object.assign({}, data, { [name]: value }) });  
                
    }

    confirm_email = (event: React.ChangeEvent<HTMLFormElement>) => {
        
        event.preventDefault();
        this.setState({isbusy: true});
        const {data} = this.state ; 

        const success_func = (r:RespArgs) => {
            if (r.status === RespStatus.success){
                const {body} = r ; 
                console.log(r.body);

                this.setState(
                    {isbusy: false }, () => {
                        this.props.navigate(
                            APPRoute.login                            
                        )  
                         
                        Alerts.show_success(r.status_msg);
                    }
                )
            } else if (r.status === RespStatus.failed){ 
                this.setState({
                    isbusy: false 
                }, () => {
                    Alerts.show_error(r.status_msg); 
                    if (r.body.form !== undefined){
                        this.setState({form: r.body.form})
                    }
                })
            }
        } 

        const error_handler = (r:RespArgs) => {
            console.log(r); 
        }


        console.log(data); 

        HttpsRequest.post(
            APIRoute.password_reset,
            data,
            success_func,
            {},
            error_handler
        )

    }
}

export {ResetPasswd}